import { FC } from "react";
import cx from "apps/website/utils/misc/cx";
import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import ImageCompareFrame from "apps/website/components/feature/ImageCompareFrame/ImageCompareFrame";
import { IImageProps } from "apps/website/components/base/Image/Image";

interface ISuccessStoryProps {
  beforeImage: IImageProps;
  afterImage: IImageProps;
  catName: string;
  testimonial: React.ReactNode;
  author: string;
  reverse?: boolean;
  animate?: boolean;
}

const SuccessStory: FC<ISuccessStoryProps> = ({
  beforeImage,
  afterImage,
  catName,
  testimonial,
  author,
  reverse = false,
  animate = false,
}) => (
  <div className={cx(
    "flex flex-col gap-8 lg:gap-10 mx-auto",
    "md:items-center",
    reverse ? "md:flex-row-reverse" : "md:flex-row",
  )}>
    <div className="flex-shrink-0">
      <ImageCompareFrame
        beforeImage={beforeImage}
        afterImage={afterImage}
        animate={animate}
      />
    </div>
    <div className="flex flex-col gap-2 md:gap-6 md:flex-1">
      <TextTitle size={3} align="center" className="uppercase">{ catName }</TextTitle>
      <TextBody size={1} className="!mb-0" align="center">
        <span>&ldquo;{ testimonial }&rdquo;</span>
      </TextBody>
      <div className="flex flex-col gap-1">
        <TextSubtitle size={1} align="center">{ author }</TextSubtitle>
        <TextSubtitle size={4} align="center">{ "(cat parent)" }</TextSubtitle>
      </div>

    </div>
  </div>
);

export default SuccessStory;
